import { Component, OnInit } from '@angular/core';
import { DataService } from '../../services/data.service';
import {
  AlertController,
  LoadingController,
  ModalController,
  NavController,
  MenuController
} from '@ionic/angular';
@Component({
  selector: 'app-replacement-policy',
  templateUrl: './replacement-policy.page.html',
  styleUrls: ['./replacement-policy.page.scss'],
})
export class ReplacementPolicyPage implements OnInit {
  issue_list:any=[]
  
  constructor(public db: DataService, public navCtrl: NavController,public menu:MenuController,public modal:ModalController) { }

  ngOnInit() {
    this.get_support();

    const modalState = {
      modal : true,
      desc : 'fake state for our modal'
    };
    history.pushState(modalState, '');
  }

   get_support() {
    // let data = { start: this.page_no, length: this.page_size,doctype: 'Return Policy' }; 
    this.db.get_replacement_policies()
      .subscribe((res: any) => {
        console.log(res);
        this.issue_list = res.message
      })
  }

   async go_to_product(item){
    if(item){
      item.status = 'success'
      await this.modal.dismiss(item);
    };
   }

}
